export const GET_COST_TRACKERS_LIST = "GET_COST_TRACKERS_LIST";
export const COST_TRACKERS_LIST = "COST_TRACKERS_LIST";

export const SEARCH_COST_TRACKER_BY_ID = "SEARCH_COST_TRACKER_BY_ID";
export const COST_TRACKER_BY_ID = "COST_TRACKER_BY_ID";

export const GET_CLOUD_PROVIDERS_LIST = "GET_CLOUD_PROVIDERS_LIST";
export const CLOUD_PROVIDERS_LIST = "CLOUD_PROVIDERS_LIST";

export const SAVE_COST_TRACKER = "SAVE_COST_TRACKER"
export const SAVE_COST_TRACKER_RESP = "SAVE_COST_TRACKER_RESP";

export const DELETE_COST_TRACKER = "DELETE_COST_TRACKER"
export const DELETE_COST_TRACKER_RESP = "DELETE_COST_TRACKER_RESP";

export const GET_ALL_EVENTS = "GET_ALL_EVENTS";
export const GET_ALL_EVENTS_RESP = "GET_ALL_EVENTS_RESP"

export const GET_EVENT_INFO = "GET_EVENT_INFO";
export const GET_EVENT_INFO_RESP = "GET_EVENT_INFO_RESP"

export const SAVE_EVENT = "SAVE_EVENT";
export const SAVE_EVENT_RESP = "SAVE_EVENT_RESP";

export const DELETE_EVENT = "DELETE_EVENT";
export const DELETE_EVENT_RESP = "DELETE_EVENT_RESP"

export const SEARCH_COST_TRACKER_BY_FIELD = "SEARCH_COST_TRACKER_BY_FIELD";
export const COST_TRACKER_BY_FIELD_LIST = "COST_TRACKER_BY_FIELD_LIST";

export const GET_COST_TRACKER_CONTRACTS = "GET_COST_TRACKER_CONTRACTS"
export const SET_COST_TRACKER_CONTRACTS = "SET_COST_TRACKER_CONTRACTS"
